import {apsCommands} from "../../shared/dto/aps.commands";
import {apsViewModels} from "../../shared/dto/APS.ViewModels";
import * as angular from "angular";
import HttpServiceName, {HttpService} from "../http/http.service";
import {Endpoints} from "../../shared/config/constant.module";

export interface ToolChangeService {
  getToolsAndTypes(): angular.IPromise<apsViewModels.ToolAndType[]>;
  addToolChange(command: apsCommands.AddToolChange): angular.IPromise<any>;
  getSectionChange(id: string, sectionId: string, shopId: string): angular.IPromise<apsViewModels.SectionChangeDetails>;
  deleteToolChange(command: apsCommands.DeleteToolChange): angular.IPromise<any>;
  addComment(command: apsCommands.AddToolChangeComment): angular.IPromise<any>;
  getToolMolds(shopId: string, time: Date): angular.IPromise<apsViewModels.MachineMold[]>;
  getToolChange(id: string): angular.IPromise<apsViewModels.TopToolChangeDetail>;
  editToolChange(command: apsCommands.EditToolChange): angular.IPromise<any>;
}

class ToolChangeServiceImpl implements ToolChangeService {
  private httpService: HttpService;

  constructor(httpService: HttpService) {
    this.httpService = httpService;
  }

  getToolsAndTypes(): angular.IPromise<apsViewModels.ToolAndType[]> {
    return this.httpService.get<apsViewModels.ToolAndType[]>(Endpoints.TOOLS_AND_TYPES);
  }

  addToolChange(command: apsCommands.AddToolChange): angular.IPromise<any> {
    return this.httpService.post(Endpoints.TOOL, command);
  }

  getSectionChange(id: string, sectionId: string, shopId: string): angular.IPromise<apsViewModels.SectionChangeDetails> {
    return this.httpService.get<apsViewModels.SectionChangeDetails>(
      Endpoints.SECTION_CHANGE + '/' + id, {shopId: shopId, sectionId: sectionId});
  }
  
  deleteToolChange(command: apsCommands.DeleteToolChange): angular.IPromise<any> {
    return this.httpService.delete(Endpoints.TOOL + '/' + command.id);
  }
  
  addComment(command: apsCommands.AddToolChangeComment): angular.IPromise<any> {
    return this.httpService.post(Endpoints.TOOL_COMMENT, command);
  }

  getToolMolds(shopId: string, time: Date): angular.IPromise<apsViewModels.MachineMold[]> {
    return this.httpService.get<apsViewModels.MachineMold[]>(
      Endpoints.TOOL_MOLDS, {shopId: shopId, time: time});
  }

  getToolChange(id: string): angular.IPromise<apsViewModels.TopToolChangeDetail> {
    return this.httpService.get<apsViewModels.TopToolChangeDetail>(Endpoints.TOOL + '/' + id);
  }

  editToolChange(command: apsCommands.EditToolChange): angular.IPromise<any> {
    return this.httpService.put(Endpoints.TOOL, command);
  }
}

export default angular
  .module('aps.services.toolChange', [HttpServiceName])
  .service('toolChangeService', ToolChangeServiceImpl)
  .name;


// WEBPACK FOOTER //
// ./src/app/services/toolChange/toolChange.service.ts